import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'obstacle'

const OPTIONS = [
  {
    value: 'Emotional attachment',
    translationKey: 'pages.onboarding.obstacle.options.emotional',
  },
  {
    value: 'No time or energy',
    translationKey: 'pages.onboarding.obstacle.options.noTime',
  },
  {
    value: 'Do not know where to start',
    translationKey: 'pages.onboarding.obstacle.options.dontKnow',
  },
  {
    value: 'Unsure what to keep or toss',
    translationKey: 'pages.onboarding.obstacle.options.unsure',
  },
  {
    value: 'Things pile up again quickly',
    translationKey: 'pages.onboarding.obstacle.options.pileUp',
  },
]

export default function ObstaclePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your biggest obstacle when decluttering?",
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.obstacle.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
